import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-subtitle-card',
  templateUrl: './note-subtitle-card.component.html',
  styleUrls: ['./note-subtitle-card.component.scss']
})
export class NoteSubtitleCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
